module.exports = __webpack_public_path__ + "static/media/7th.1e216fb6.png";